import { Stack, Box, Typography, Paper, Chip } from "@mui/material";
import type { LanguageShowData } from "@/admin/entities/languages";
import { CustomCellDate } from "@/shared/components";

interface LanguageDetailsProps {
  language: LanguageShowData;
}

export function LanguageDetails({ language }: LanguageDetailsProps) {
  if (!language) {
    return (
      <Paper sx={{ p: 2 }}>
        <Typography variant="h6" color="error">
          Запись не найдена
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper sx={{ p: 2 }}>
      <Stack spacing={2}>
        <Typography variant="h6">{language.title}</Typography>

        <Box>
          <Typography variant="body2" color="text.secondary">
            Код
          </Typography>
          <Typography variant="body1">{language.code}</Typography>
        </Box>

        <Box>
          <Typography variant="body2" color="text.secondary">
            Родное название
          </Typography>
          <Typography variant="body1">{language.native}</Typography>
        </Box>

        <Box>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Участвует в переводах
          </Typography>
          <Chip
            label={language.translation ? "Вкл" : "Выкл"}
            color={language.translation ? "success" : "default"}
            size="small"
          />
        </Box>

        <Box>
          <Typography variant="body2" color="text.secondary">
            ID
          </Typography>
          <Typography variant="body1">{language.id}</Typography>
        </Box>

        <Box>
          <Typography variant="body2" color="text.secondary">
            Создан
          </Typography>
          <CustomCellDate date={language.createdAt} />
        </Box>

        <Box>
          <Typography variant="body2" color="text.secondary">
            Обновлён
          </Typography>
          <CustomCellDate date={language.updatedAt} />
        </Box>

        {language.deletedAt ? (
          <Box>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Статус
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center">
              <Chip label="Удалён" color="warning" size="small" />
              <CustomCellDate date={language.deletedAt} />
            </Stack>
          </Box>
        ) : null}
      </Stack>
    </Paper>
  );
}
